<!-- Current school -->
<div class="current-school" *ngIf="currentSchool$ | async as school">
    <div class="row info-line" *ngIf="school.educationLevel">
        <div class="col-md-4"><span class="icon i-graduation-cap"></span>{{ 'REPERTOIRE.FORMS.EDUCATION-LEVEL.TITLE' | translate }}</div>
        <div class="col-md-8" *ngFor="let edLevel of school.educationLevel; let i = index" [ngClass]="{ 'offset-md-4': i > 0 }">
            {{ 'ENUM.EDUCATION-LEVEL.' + edLevel.type.toUpperCase() | translate }}
        </div>
    </div>

    <div class="row info-line" *ngIf="school.email">
        <div class="col-md-4"><span class="icon i-mail"></span>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.EMAIL' | translate }}</div>
        <a class="col-md-8" href="mailto:{{ school.email }}">{{ school.email }}</a>
    </div>
    <div class="row info-line" *ngIf="school.mobileNumber">
        <div class="col-md-4"><span class="icon i-mobile"></span>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.MOBILE-NUMBER' | translate }}</div>
        <a href="tel:{{ school.mobileNumber }}" class="col-md-8">{{ school.mobileNumber }}</a>
    </div>
    <div class="row info-line" *ngIf="school.homeNumber">
        <div class="col-md-4"><span class="icon i-phone"></span>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.HOME-NUMBER' | translate }}</div>
        <a href="tel:{{ school.homeNumber }}" class="col-md-8">{{ school.homeNumber }}</a>
    </div>
    <div class="row info-line" *ngIf="school.website">
        <div class="col-md-4"><span class="icon i-globe"></span>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.WEBSITE' | translate }}</div>
        <a class="col-md-8" [href]="school.website">{{ school.website }}</a>
    </div>

    <div class="row info-line" *ngIf="school.address && school.address.street">
        <div class="col-md-4"><span class="icon i-home"></span>{{ 'REPERTOIRE.CONTACTS.PROFILE.ADDRESS' | translate }}</div>
        <div class="col-md-8">
            {{ school.address.street }} {{ school.address.home_number + (school.address.box ? '/' + school.address.box : '') }}
            <br />
            {{ school.address.additional_information }}<br *ngIf="school.address.additional_information" />
            {{ school.address.postal_code }} {{ school.address.city }}<br />
            {{ school.address.country }}
        </div>
    </div>

    <div class="row info-line" *ngIf="school.schedules">
        <div class="col-md-4"><span class="icon i-calendar"></span>{{ 'REPERTOIRE.FORMS.SCHEDULES.TITLE' | translate }}</div>
        <div class="col-md-8">
            <div class="row schedules" *ngFor="let day of school.schedules">
                <span class="col-2">{{ 'ENUM.WEEK-DAYS.ABBREVIATION.' + day.day.toUpperCase() | translate }}</span>
                <span class="col">{{ 'REPERTOIRE.FORMS.SCHEDULES.START-TIME-PLACEHOLDER' | translate }}: {{ day.start_time }}</span>
                <span class="col">{{ 'REPERTOIRE.FORMS.SCHEDULES.END-TIME-PLACEHOLDER' | translate }}: {{ day.end_time }}</span>
            </div>
        </div>
    </div>
</div>
